import { StrictMode } from 'react';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App.tsx';
import './i18n/i18n.ts';

Sentry.init({
  dsn: 'https://b53c70ee9d884631c9ac319140a28062@o4510464628948992.ingest.de.sentry.io/4510503918960720',
  environment: import.meta.env.MODE === 'production' ? 'production' : 'development',
  sendDefaultPii: false,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
